import React, { forwardRef } from "react";
import { Box, DropdownLayout } from "@wix/design-system";
import {
  SURFACE_OVERLAY_COLOR,
  DROPDOWN_BORDER_COLOR,
} from "@wix/picasso-common";
import { useThemeDropdown } from "./useThemeDropdown";
import type { ThemeOption } from "./themeUtils";
import { useMobile } from "../../../../hooks/useMobile";

interface ThemeDropdownProps {
  isVisible: boolean;
  onClose: () => void;
}

export const ThemeDropdown = forwardRef<HTMLDivElement, ThemeDropdownProps>(
  ({ isVisible, onClose }, ref) => {
    const { selectedThemeOption, handleThemeSelect, themeOptions } =
      useThemeDropdown({
        onClose,
      });
    const isMobile = useMobile();

    if (!isVisible) {
      return null;
    }

    if (isMobile) {
      return (
        <Box padding="16px 8px">
          <DropdownLayout
            minWidthPixels={120}
            maxHeightPixels={200}
            visible={true}
            selectedId={selectedThemeOption}
            options={themeOptions}
            onSelect={(option) => handleThemeSelect(option.id as ThemeOption)}
            inContainer
            size="small"
          />
        </Box>
      );
    }

    return (
      <Box
        ref={ref}
        padding="4px"
        backgroundColor={SURFACE_OVERLAY_COLOR}
        zIndex={1001}
        position="absolute"
        top="70px"
        {...(document.documentElement.dir === "rtl"
          ? { left: "264px" }
          : { right: "264px" })}
        borderRadius="8px"
        border={`1px solid ${DROPDOWN_BORDER_COLOR}`}
        boxShadow="0px 0px 18px 0px rgba(0, 6, 36, 0.10), 0px 6px 6px 0px rgba(0, 6, 36, 0.00)"
        direction="vertical"
        minWidth="150px"
      >
        <DropdownLayout
          minWidthPixels={120}
          maxHeightPixels={200}
          visible={true}
          selectedId={selectedThemeOption}
          options={themeOptions}
          onSelect={(option) => handleThemeSelect(option.id as ThemeOption)}
          inContainer
          size="small"
        />
      </Box>
    );
  },
);

ThemeDropdown.displayName = "ThemeDropdown";
